import { render, staticRenderFns } from "./SalesV3.vue?vue&type=template&id=68047e19&scoped=true"
import script from "./SaleScript.js?vue&type=script&lang=js&external"
export * from "./SaleScript.js?vue&type=script&lang=js&external"
import style0 from "./SalesV3.vue?vue&type=style&index=0&id=68047e19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68047e19",
  null
  
)

export default component.exports